export default __webpack_public_path__ + "static/media/DSC_0550.2d1f6bdb.webp";